import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  ITransferOrderSearchFilterBody,
  ITransferOrderSearchResponse,
  ITransferOrderSearchResponseData,
} from "@/api_framework/api_modals/TransferOrder";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useTransferOrderSearchAPI = () => {
  const configuration = useConfiguration();
  const [searchData, setSearchData] = useState<ITransferOrderSearchResponseData[] | null>(null);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const clearSearchResults = () => {
    setSearchData(null);
  };

  const execute = useCallback(
    async (filterBody: ITransferOrderSearchFilterBody, searchQuery: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const params = new URLSearchParams();
        params.append("page_size", "10");
        params.append("page_number", "1");
        if (searchQuery) {
          params.append("search_query", searchQuery);
        }
        const url = `${INVENTORY_MODULE?.TRANSFER_ORDER_SEARCH?.baseURL}?${params.toString()}`;
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(url, filterBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ITransferOrderSearchResponse>) => {
            if (res.data.status === true) {
              const rawItems: any[] = Array.isArray(res.data.data)
                ? res.data.data
                : (res.data.data as any)?.data ?? [];
              const items: ITransferOrderSearchResponseData[] = rawItems.map((item: any) => ({
                vetic_variant_name: item.product_name ?? item.vetic_variant_name,
                vetic_variant_id: item.vetic_variant_id,
              }));
              setSearchData(items);
              return { status: true, message: "batch" };
            } else {
              setSearchData(null);
              return { status: false, message: "product_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "product_not_filtered" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { searchData, execute, clearSearchResults };
};
